var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.39961L11.9999 11.9996C11.9999 12.8833 11.2836 13.5996 10.3999 13.5996L3.9999 13.5996C3.11625 13.5996 2.3999 12.8833 2.3999 11.9996L2.3999 5.59961C2.3999 4.71595 3.11625 3.99961 3.9999 3.99961L7.5999 3.99961",
    stroke: "#2E2E2E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 10.002L12.8001 3.20195",
    stroke: "#2E2E2E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4126 3.20117H12.8008V6.40117",
    stroke: "#2E2E2E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToVote);
export default __webpack_public_path__ + "static/media/to_vote.e7865eebd83910c566200497b0411323.svg";
export { ForwardRef as ReactComponent };